import {
  CLEAR_LAST_LANDING_SLUG,
  SET_LAST_LANDING_SLUG,
} from "../actions/navigation.actions";
import { createReducer } from "@reduxjs/toolkit";

export const navigationReducer = createReducer(
  {
    lastLandingSlug: null,
  },
  (builder) =>
    builder
      .addCase(SET_LAST_LANDING_SLUG, (state, action) => {
        state.lastLandingSlug = action.payload;
      })
      .addCase(CLEAR_LAST_LANDING_SLUG, (state) => {
        state.lastLandingSlug = null;
      })
);
